import * as React from 'react';
import SpinnerSvg from './images/spinner.svg';
import './globalLoader.module.scss';

export class GlobalLoader extends React.Component {
  render() {
    return (
      <div id="global-loader" styleName="loader-overlay">
        <img styleName="spinner" src={SpinnerSvg} />
      </div>
    );
  }
}
